import type { ExtensionReleaseMetadata } from '@erp/shared'

function hex(bytes: ArrayBuffer): string {
  return Array.from(new Uint8Array(bytes), (value) => value.toString(16).padStart(2, '0')).join('')
}

export async function verifyExtensionArtifact(data: ArrayBuffer, metadata: ExtensionReleaseMetadata): Promise<void> {
  const bytes = new Uint8Array(data)
  if (data.byteLength !== metadata.bytes) throw new Error('插件文件大小与发布记录不一致')
  if (bytes[0] !== 0x50 || bytes[1] !== 0x4b) throw new Error('插件下载结果不是 ZIP 文件')
  const digest = hex(await crypto.subtle.digest('SHA-256', bytes))
  if (digest !== metadata.sha256) throw new Error('插件文件 SHA-256 与发布记录不一致')
}

/** Fetch, verify, then expose the exact bytes; a broken static route never becomes a user download. */
export async function downloadVerifiedExtension(metadata: ExtensionReleaseMetadata): Promise<void> {
  const response = await fetch(metadata.downloadUrl, { cache: 'no-store', credentials: 'omit' })
  if (!response.ok) throw new Error(`插件文件不可下载（HTTP ${response.status}）`)
  const data = await response.arrayBuffer()
  await verifyExtensionArtifact(data, metadata)
  const objectUrl = URL.createObjectURL(new Blob([data], { type: 'application/zip' }))
  try {
    const link = document.createElement('a')
    link.href = objectUrl
    link.download = `crossborder-extension-${metadata.version}.zip`
    link.click()
  } finally {
    URL.revokeObjectURL(objectUrl)
  }
}
